import React, {useState} from "react";
import QnaModal from "../item/QnaModal";
import QnaUpdateModal from "../item/QnaUpdateModal";

const QnaCard = ({ item, refreshQnaData }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className="qna-card">
            {/* 상단 Q&A 정보 */}
            <div className="qna-info">
                <div className="qna-thumbnail">
                    <img src={item.thumbnailPath} alt={item.productName}/>
                </div>
                <div className="qna-details">
                    <h4 className="qna-title">{item.productName}</h4>
                    <p className="qna-subtitle">{item.productDescription}</p>
                </div>
            </div>

            {/* 작성된 질문 */}
            <p className="qna-date">{item.regDate}</p>
            <h4 className="qna-title">{item.title}</h4>
            <p className="qna-content">{item.content}</p>

            {/* ✅ 답변이 완료된 경우 답변 추가 표시 */}
            {item.answer != null && (
                <div className="qna-answer">
                    <p className="qna-answer-date">{item.commentDate}</p>
                    <p className="qna-answer-content">{item.answer}</p>
                </div>
            )}

            {/* 우측 버튼 */}
            <div className="qna-actions">
                <button className={`qna-status-btn ${item.answer !== null ? "completed" : "pending"}`}>
                    {item.answer !== null ? "답변완료" : "답변대기"}
                </button>
                <button className="qna-edit-btn" disabled={item.answer != null} onClick={() => setIsModalOpen(true)}>
                    수정하기
                </button>
                {/* 모달 */}
                <QnaUpdateModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} itemId={item.productId} onQnaSubmitted={refreshQnaData} qnaId={item.articleId} />
            </div>
        </div>
    );
};

export default QnaCard;
